import { render, staticRenderFns } from "./FormularioUsuario.vue?vue&type=template&id=50ae4894&"
import script from "./FormularioUsuario.vue?vue&type=script&lang=ts&"
export * from "./FormularioUsuario.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports